import { CMHKLangMap } from '@repo/common-utils/constants/myLinkMap'
import { isHLApp } from '@fs/utils'
import { getAppLocale, toLegacyLangType } from '@repo/common-utils/utils/appLocale'
import { getDiffConfig } from '../http.tool'
import { ENCRYPT_TYPES } from '../contansts'

// 某些条件下自定义请求头的数据
export default async (config) => {
  console.log('config--', config)
  if (!isHLApp() || config.jsBridge === false) {
    const legacyLang = toLegacyLangType(getAppLocale())
    const lang = config.isZyd == 1 ? CMHKLangMap[legacyLang] || legacyLang : legacyLang
    config.headers['X-lang'] = lang
    // 加密接口场景下对于x-session的特殊处理
    if (config.scene) {
      const urlVersion = config.url.indexOf('/v0/') == -1
      const sessionKey = urlVersion ? 'session' : 'WTtoken'
      const session = localStorage.getItem(sessionKey) || ''
      const currDiffConfig = getDiffConfig(config.scene)
      config.headers['X-session'] = urlVersion
        ? `${currDiffConfig.sessionKey}=${session}`
        : `fhsId=${session}`

      const isTrade = [ENCRYPT_TYPES.TRADE, ENCRYPT_TYPES.FORCE_TRADE].includes(config.encrypt)
      if (isTrade && urlVersion) {
        config.headers['X-session'] =
          `session=${session};session2=${localStorage.getItem('session2')}`
      }
    }
  }
  const position = localStorage.getItem('position')
  if (position) {
    if (isHLApp() && config.jsBridge === true) {
      if (config.headerMap) {
        config.headerMap['X-position'] = position
      }
    } else {
      config.headers['X-position'] = position
    }
  }

  const esopUrl = config.url.indexOf('/esop/') !== -1
  if (esopUrl) {
    const sessionEsop = localStorage.getItem('session') || ''
    if (sessionEsop) {
      if (isHLApp() && config.jsBridge === true) {
        if (config.headerMap) {
          config.headerMap['X-session'] += `sessionEsop=${sessionEsop}`
        }
      } else {
        config.headers['X-session'] += `sessionEsop=${sessionEsop}`
      }
    }
  }

  // const sessionEsop = localStorage.getItem('sessionEsop') || ''

  // if (sessionEsop) {
  //     if (isHLApp() && config.jsBridge === true) {
  //         if (config.headerMap) {
  //             config.headers['X-session'] += `;sessionEsop=${sessionEsop}`
  //         }
  //     } else {
  //         config.headers['X-session'] += `;sessionEsop=${sessionEsop}`
  //     }
  // }

  return config
}
